import { memo } from 'react'
import './BottomMenu.css'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Home } from '../../icon/home.svg'
import { ReactComponent as Account } from '../../icon/account.svg'

function BottomMenuComponent() {
	const { t } = useTranslation()
	const authorized = localStorage.getItem('authorized')
	// const communityUid = localStorage.getItem('communityUid')
	const navigate = useNavigate()

	const goToMainPage = () => {
		let mainLink = '/'

		if (authorized === 'true') {
			mainLink = '/tournaments'
		}
		else {
			mainLink = '/'
		}
		navigate(mainLink)
	}

	const goToAccountPage = () => {
		let link = '/login'

		if (authorized === 'true') {
			link = '/account'
		}
		navigate(link)
	}

	return (
		<div className="bottom-menu__container">
			<div onClick={goToMainPage} className="bottom-menu__link">
				<Home className="icon-home" />

				<p className="bottom-menu__title">
					{t('Home')}
				</p>
			</div>

			<div onClick={goToAccountPage} className="bottom-menu__link">
				<p className="bottom-menu__title">
					{t('Account')}
				</p>

				<Account className="icon-account" />
			</div>
		</div>
	)
}

export const BottomMenu = memo(BottomMenuComponent)